<div class="pipeline-tracker" [class.is-cancelled]="cancelled">
  <div
    *ngFor="let stage of normalizedStages()"
    class="pipeline-stage"
    [attr.data-step-type]="stage.stepType"
    [attr.data-step-id]="stage.key"
    [class.is-past]="isPast(stage)"
    [class.is-current]="isCurrent(stage)"
    [style.--pipeline-stage-bg]="stageBackground(stage)"
    [style.color]="stageForeground(stage)"
  >
    <span *ngIf="stage.stepType === 'inventory_movement'" class="inventory-step-marker" title="Inventory movement" aria-label="Inventory movement">◆</span>
    <span class="pipeline-stage-label">{{ stage.label }}</span>
    <span
      *ngIf="stage.verificationRequired"
      class="pipeline-stage-verification"
      title="Verification required"
      aria-label="Verification required"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
        aria-hidden="true"
      >
        <path d="M12 22s8 -4 8 -10v-5l-8 -3l-8 3v5c0 6 8 10 8 10" />
        <path d="M9 12l2 2l4 -4" />
      </svg>
    </span>
  </div>
</div>
